import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { baseCss } from '@nuvvu/ui';
import { App } from './App.js';

const style = document.createElement('style');
style.textContent = baseCss;
document.head.appendChild(style);

const root = document.getElementById('root');
if (!root) throw new Error('#root no existe');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
